import _Vue from "vue";
import HigBtn from "components/custom/HigBtn.vue";

const install = (Vue: typeof _Vue) => {
  Vue.component(HigBtn.name, HigBtn);
};
export default {
  install,
};
